import { Link } from "react-router-dom";
import TreeMenu from "../../components/LeftTreeMenu/LeftTreeMenu";

export default function MainMenu(){
    const handleToggle = (item, isOpen) => {
        console.log(`Menu item ${item.name} ${isOpen ? 'opened' : 'closed'}`);
    };
    const menuItems = [
        { 
            "name": "基础数据管理",
            "subs": [
                {
                    "name": "产品档案管理",
                    "note":	"产品编码、名称、规格、颜色、尺寸、类别、图片、供应商信息、价格",
                    "to": "pdts"
                },
                {
                    "name":"仓库与库位管理",
                    "note":	"多仓库支持，库区/货架/库位编码，库位数量限制",
                    "to": "poses"
                }
            ]
        },
        {
            "name":"库存管理功能",
            "subs":	[
                {
                    "name": "实时库存查询",
                    "note":	"产品现有数量、可用库存、安全库存警戒线"
                },
                {
                    "name":"库存调整",
                    "note":	"报损、报溢记录，盘点差异调整"
                },
                {
                    "name":"库存预警",
                    "note":	"低于安全库存自动提醒采购，超储提醒"
                }
            ]
        },
        {
            "name":"入库管理",
            "subs":	[
                {
                    "name": "采购入库",
                    "note":	"按采购订单生成入库单，入库数量匹配，质检记录"
                },
                {
                    "name":"退货入库",
                    "note":	"客户退货入库记录，与销售单关联,并增加一个虚拟退货库，便于查看退货待处理货品"
                },
                {
                    "name":"调拨入库",
                    "note":	"跨仓库调拨记录"
                }
            ]
        },
        {
            "name":"出库管理",
            "subs":	[
                {
                    "name": "销售出库",
                    "note":	"按销售订单生成出库单，自动扣减库存"
                },
                {
                    "name":"样品出库",
                    "note":	"样品出库登记，样品回收/核销管理"
                },
                {
                    "name":"退货出库",
                    "note":	"向供应商退货记录"
                }
            ]
        },
        {
            "name":"库存追踪与分析",
            "subs":	[
                {
                    "name": "库存流水记录",
                    "note":	"产品进出库历史追溯到采购单、销售单、调拨单"
                },
                {
                    "name":"批次/序列号管理",
                    "note":	"生产批次、生产日期、有效期"
                },
                {
                    "name":"库存报表",
                    "note":	"库存统计、周转率、畅销与滞销分析"
                }
            ]
        },
        {
            "name":"销售人员可视化查询",
            "subs":	[
                {
                    "name": "快速库存搜索",
                    "note":	"按编码、名称、类别检索，显示可用库存与预计到货时间"
                },
                {
                    "name":"销售支持数据",
                    "note":	"客户订单关联库存状态，库存锁定功能"
                }
            ]
        },
        {
            "name":"系统集成与权限",
            "subs":	[
                {
                    "name": "系统对接",
                    "note":	"与采购、销售系统对接，销售下单自动扣减库存，采购到货更新库存"
                },
                {
                    "name":"权限管理",
                    "note":	"销售可查库存但不可改库存，采购、仓储可录入与调整库存"
                }
            ]
        }
    ];
    return <TreeMenu
        items={menuItems}
        onToggle={handleToggle}
    />
}